module.exports = __webpack_public_path__ + "img/img_2_b_.ef818d4b.png";